import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { Tooltip, TooltipProps } from "@mui/material";
import { ConfirmModalContext, ModalProps } from "context/confirmModalContext";
import { useContext } from "react";

interface CancelExaminationButtonProps {
  buttonProps?: LoadingButtonProps;
  tooltipProps?: Omit<TooltipProps, "children">;
  withConfirmation?: boolean;
  handleCancelExamination: () => void;
  confirmModalProps?: Partial<Omit<ModalProps, "handleClick">>;
}

const CancelExaminationButton = ({
  buttonProps,
  tooltipProps,
  withConfirmation = true,
  handleCancelExamination,
  confirmModalProps,
}: CancelExaminationButtonProps) => {
  const { title, ...restTooltipProps } = tooltipProps || {};
  const { handleOpen } = useContext(ConfirmModalContext);

  const onCancel = () => {
    if (withConfirmation) {
      handleOpen({
        title: "Подтвердите завершение тестирования",
        description: "Кандидат не сможет приступить к тестированию после отмены.",
        actionButtonText: "Подтвердить",
        handleClick: handleCancelExamination,
        ...confirmModalProps,
      });
    } else {
      handleCancelExamination();
    }
  };

  return (
    <Tooltip
      title={title}
      {...restTooltipProps}>
      <span>
        <LoadingButton
          variant='contained'
          color='secondary'
          onClick={onCancel}
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 0px 7.3px 0px rgba(164, 184, 253, 0.24)",
            whiteSpace: "nowrap",
          }}
          {...buttonProps}>
          Завершить тестирование
        </LoadingButton>
      </span>
    </Tooltip>
  );
};

export default CancelExaminationButton;
